import { useEffect } from 'react'

import { cn } from 'src/shared/utils/cn'

import FileUploadBox from '../../components/file-upload-box'
import WarningIcon from '../../components/warning-icon'
import { FOOTER_DISCLAIMER_TEXT } from '../../constants/ul-copy'
import { useUploadLeadsContext } from '../../context/upload-leads-context'
import { type UploadedFileMeta, useUploadLeadsStore } from '../../store/upload-leads-store'

export default function UploadLeadsStep() {
  const { uploadedFile } = useUploadLeadsStore((state) => state.formData)
  const setFormData = useUploadLeadsStore((state) => state.setFormData)
  const { setFooterConfig } = useUploadLeadsContext()
  const isUploaded = Boolean(uploadedFile?.previewData)

  const handleUploadedFileChange = (fileMeta: UploadedFileMeta | null) => {
    const { formData } = useUploadLeadsStore.getState()
    setFormData({
      ...formData,
      uploadedFile: fileMeta,
      uploadedFileHasClosedDate: fileMeta?.previewData.closedAtColumnExists ?? false,
    })
  }

  useEffect(() => {
    setFooterConfig({
      isPrimaryDisabled: !uploadedFile?.previewData,
      bottomLeftContent: {
        variant: 'icon-text',
        text: FOOTER_DISCLAIMER_TEXT,
        icon: <WarningIcon />,
      },
    })

    return () => {
      setFooterConfig(null)
    }
  }, [setFooterConfig, uploadedFile])

  return (
    <div className={cn('flex size-full items-center justify-center px-5')}>
      <div className="mx-auto w-full max-w-[500px]">
        <div className="flex flex-col items-center gap-10">
          <div className="flex w-full max-w-[460px] flex-col items-center text-center">
            <h1 className="text-[36px] font-semibold leading-tight tracking-[-0.36px] text-primary">
              {isUploaded ? 'File uploaded' : 'Upload leads'}
            </h1>
            <p className="mt-2 text-[18px] font-medium leading-[1.6] text-muted">Upload existing database</p>
          </div>

          <FileUploadBox initialFile={uploadedFile} onFileChange={handleUploadedFileChange} />
        </div>
      </div>
    </div>
  )
}
